export default __webpack_public_path__ + "Location-on.707e5037ac89b80bf15f3f610ff48d4b.svg";